export enum ReportTypes {
  BILLINGS = 'billings',
  TRANSACTIONS = 'transactions',
}

export enum ReportLayout {
  GRAPH = 'graph',
  TABLE = 'table',
}
